module.exports = __webpack_public_path__ + "img/proList2_27_16.8770e050.jpg";